import styled from '@emotion/styled';
import { Heading3 } from '@blueprint/heading';
import { css } from '@emotion/react';
import { Link } from '@blueprint/link';

const List = styled('ul')`
    list-style: none;
    padding: 0;
    margin: 0;
    text-decoration: none;
    display: flex;
    flex-wrap: wrap;
`;

const ListItem = styled('li')((props) => {
    const {
        theme: { spacing }
    } = props;

    return css`
        list-style: none;
        margin: 0 auto ${spacing['spacing-4']} auto;
        padding: 0;
    `;
});

const StyledLinkItem = styled('li')((props) => {
    const {
        theme: { spacing, colors, fontSizes }
    } = props;

    return css`
        list-style: none;
        width: calc(100% / 2);
        padding: ${spacing['spacing-2']} 0;
        font-size: ${fontSizes['1']};
        line-height: inherit;
        text-decoration: none;

        @media only screen and (min-width: 350px) {
            font-size: ${fontSizes['2']};
        }

        @media only screen and (min-width: 550px) {
            width: calc(100% / 3);
        }

        ${Link} {
            color: ${colors['primary-dark']};
            text-decoration-color: transparent;
            font-weight: normal;
            border-radius: 5px;
        }

        ${Link}:hover {
            text-decoration-color: ${colors['purple-mid']};
        }
    `;
});

const StyledSection = styled('section')((props) => {
    const {
        theme: { colors }
    } = props;

    return css`
        color: ${colors['white']};
    `;
});

const StyledHeading3 = styled(Heading3)((props) => {
    const {
        theme: { spacing, type }
    } = props;

    return css`
        margin: ${spacing['spacing-3']} 0 ${spacing['spacing-3']} 0;
        line-height: ${type.lineHeight};
    `;
});

export { List, ListItem, StyledLinkItem, StyledSection, StyledHeading3 };
